import { RSAA, RSAAAction } from 'redux-api-middleware';

import { FetchMoEventsParticipants } from './mo.types';

const FETCH_MO_EVENTS_REQUEST = 'FETCH_MO_EVENTS_REQUEST';
const FETCH_MO_EVENTS_SUCCESS = 'FETCH_MO_EVENTS_SUCCESS';
const FETCH_MO_EVENTS_FAILURE = 'FETCH_MO_EVENTS_FAILURE';

export const fetchMoEvents: () => RSAAAction = () => ({
  [RSAA]: {
    types: [FETCH_MO_EVENTS_REQUEST, FETCH_MO_EVENTS_SUCCESS, FETCH_MO_EVENTS_FAILURE],
    endpoint: `/mo`,
    method: 'GET',
  },
});

const FETCH_MO_EVENT_PARTICIPANT_REQUEST = 'FETCH_MO_EVENT_PARTICIPANT_REQUEST';
const FETCH_MO_EVENT_PARTICIPANT_SUCCESS = 'FETCH_MO_EVENT_PARTICIPANT_SUCCESS';
const FETCH_MO_EVENT_PARTICIPANT_FAILURE = 'FETCH_MO_EVENT_PARTICIPANT_FAILURE';

export const fetchMoEventsParticipants: (eventId: string) => RSAAAction = eventId => ({
  [RSAA]: {
    types: [FETCH_MO_EVENT_PARTICIPANT_REQUEST, FETCH_MO_EVENT_PARTICIPANT_SUCCESS, FETCH_MO_EVENT_PARTICIPANT_FAILURE],
    endpoint: `/mo/${eventId}`,
    method: 'GET',
  },
});

export const SYNCHRONIZE_MO_EVENT_PARTICIPANTS_REQUEST = 'SYNCHRONIZE_MO_EVENT_PARTICIPANTS_REQUEST';
export const SYNCHRONIZE_MO_EVENT_PARTICIPANTS_SUCCESS = 'SYNCHRONIZE_MO_EVENT_PARTICIPANTS_SUCCESS';
export const SYNCHRONIZE_MO_EVENT_PARTICIPANTS_FAILURE = 'SYNCHRONIZE_MO_EVENT_PARTICIPANTS_FAILURE';

export const synchronizeMOEventParticipants: FetchMoEventsParticipants = eventId => ({
  [RSAA]: {
    types: [
      SYNCHRONIZE_MO_EVENT_PARTICIPANTS_REQUEST,
      { type: SYNCHRONIZE_MO_EVENT_PARTICIPANTS_SUCCESS, meta: { eventId } },
      SYNCHRONIZE_MO_EVENT_PARTICIPANTS_FAILURE,
    ],
    endpoint: '/mo/synchronize',
    method: 'POST',
    body: {
      // @ts-ignore
      eventId,
    },
  },
});
